import { useEffect, useState } from 'react';

import StatApi from '../../api/statApi';
import EnrollmentService from '../../services/enrollmentService';
import { UserProfileService } from '../../services/userProfileService';
import { UserProfileWithCompleteSections } from '../../types/compound/progressTypes';
import SkillData from '../../types/skillData';

export default function useUserProfilesWithCompleteSections(skill: SkillData | undefined) {
  const [userProfiles, setUserProfiles] = useState<UserProfileWithCompleteSections[]>();

  useEffect(() => {
    async function fetchData() {
      if (!skill) return;
      const enrolledUuids = await EnrollmentService.getUserIdsEnrolledInSkill(skill);
      const stats = await StatApi.getSectionStatsBySkillId(skill.id);
      const fetchedUserProfiles: UserProfileWithCompleteSections[] = (
        await UserProfileService.getUserProfilesFromUuids(enrolledUuids)
      ).map(userProfile => {
        const completeSections = stats.filter(stat => stat.userUid === userProfile.uuid).length;
        return { ...userProfile, completeSections };
      });
      setUserProfiles(fetchedUserProfiles);
    }

    fetchData();
  }, [skill]);

  return userProfiles;
}
